<style scoped lang="scss" type="text/scss">

</style>

<template>
    <card class="left-panel-container">
        <square-info-block
                v-for="(item, index) in items" :key="index"
                @click.native="redirect(item.route_name)"
                :active="currentRouteName === item.route_name" :icon="item.icon">
            {{ item.title }}
        </square-info-block>
    </card>
</template>

<script>
    import Card from '../../../../components/card';
    import SquareInfoBlock from '../../../../components/square-info-block';
    import ROUTE_NAME from '../../../../router/names';

    export default {
        name: '',
        components: {
            Card,
            SquareInfoBlock
        },
        data () {
            return {
                items: [
                    {
                        title: '待处理',
                        icon: '&#xe6ad;',
                        route_name: ROUTE_NAME.ADMIN.COMPETITION.PLAYER_APPLICATION_UNFINISHED
                    },
                    {
                        title: '已完成',
                        icon: '&#xe60e;',
                        route_name: ROUTE_NAME.ADMIN.COMPETITION.PLAYER_APPLICATION_FINISHED
                    }
                ]
            };
        },
        computed: {
            currentRouteName () {
                return this.$route.name;
            }
        },
        methods: {
            redirect (routeName) {
                this.$router.push({
                    name: routeName
                });
            }
        }
    };
</script>
